<div class="sd-alternative-label" *ngIf="productTypeCode === ProductTypeCode.sda || productTypeCode === ProductTypeCode.umbrellaSda">
  <span title="Security Deposit Alternative">SD (Alternative)</span>
</div>

<div class="sd-regular-label"
  *ngIf="productTypeCode === ProductTypeCode.fsd">
  <span title="Security Deposit Regular">SD (Regular)</span>
</div>

<div class="sd-full-installments-label"
  *ngIf="productTypeCode === ProductTypeCode.sdi || productTypeCode === ProductTypeCode.umbrellaSdi">
  <span title="Security Deposit Installments">SD (Installments)</span>
</div>

<div class="sd-full-subscription-label" *ngIf="productTypeCode === ProductTypeCode.sds">
  <span title="Security Deposit Subscription">SD (Subscription)</span>
</div>
